import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { PatientProfileInfoAccordion } from '../PatientProfileInfoAccordion';
import { PatientAddress, PatientAddressProps } from './PatientAddress.component';


export type AddressAccordionProps = PatientAddressProps;

export const AddressAccordion: React.FC<AddressAccordionProps> = (props) => {
  const chip = React.useMemo(() => {
    if (props.address && props.state) {
      if (props.county && props.county.length > 33) {
        return (
          <Tooltip title={props.county} arrow>
            <Chip size="small" label={`${props.county.slice(0, 33)}..., ${props.state.shortName}`} />
          </Tooltip>
        );
      }

      return (
        <Chip size="small" label={`${props.county}, ${props.state.shortName}`} />
      );
    }

    return null;
  }, [ props.address, props.state, props.county ]);

  if (!props.address) {
    return (
      <PatientProfileInfoAccordion
        title="Address"
        chip={<Chip size="small" label="None" />}
      />
    );
  }

  return (
    <PatientProfileInfoAccordion
      title="Address"
      chip={chip}
      compensateExpandableIcon
    >
      <PatientAddress address={props.address} state={props.state} county={props.county} />
    </PatientProfileInfoAccordion>
  );
};
